
import { useEffect } from "react";

import { Provider } from "react-redux";

import socket from "./utils/Socket";
import { notificationToast } from "./utils/Notification";
import RouteNavigation from "./Routes";
import store from "./store/store";
import { BrowserRouter } from "react-router-dom";


function App() {
  // ----------------------------------------------------
  // 3️⃣ Socket Notifications (Runs ONCE)
  // ----------------------------------------------------
  useEffect(() => {
    socket.on("notification", (data) => {
      notificationToast(data); // Show toast popup
    });

    return () => {
      socket.off("notification");
    };
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <RouteNavigation />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
